import { render, staticRenderFns } from "./EmptyAlert.vue?vue&type=template&id=2d703b65&scoped=true&"
import script from "./EmptyAlert.vue?vue&type=script&lang=js&"
export * from "./EmptyAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d703b65",
  null
  
)

export default component.exports